import React from 'react';

import styled from 'styled-components';

export default function Principle() {
  return (
    <StyledPrinciple>
      <StyledPrincipleContentsContainer>
        <StyledTag>OUR CULTURE</StyledTag>
        <StyledPrincipleList>
          <StyledPrincipleContent>
            <StyledTitle>
              우리는 수평적인 문화를 <br />
              추구합니다.
            </StyledTitle>
            <StyledDescription>
              우리는 영어 닉네임을 사용하며, 단순히 영어 닉네임만
              <br />
              사용한다고 조직의 수평적인 문화가 확립되지는 않는다고 믿습니다.
              <br />
              회사 내 수평적인 문화를 갖추기 위해 항상 노력합니다.
            </StyledDescription>
          </StyledPrincipleContent>
          <StyledPrincipleContent>
            <StyledTitle>
              주도적인 업무 진행과
              <br />
              성장의 기회가 주어집니다
            </StyledTitle>
            <StyledDescription>
              연차, 직급, 직무라는 틀에 개인의 능력을 가두지 않습니다. <br />
              회사에서 본인이 기여할 수 있는 분야에는 무엇이든
              <br />
              기여하면서 성장할 수 있습니다.
              <br />
            </StyledDescription>
          </StyledPrincipleContent>
          <StyledPrincipleContent>
            <StyledTitle>
              효율적인 커뮤니케이션을
              <br />
              추구합니다
            </StyledTitle>
            <StyledDescription>
              회의는 최소한으로 진행하는 것을 추구합니다. 반드시 회의를
              <br />
              진행해야 한다면 회의의 결과로 도출되는 액션 아이템이
              <br />
              명확해야 하고 그것이 기록되고 지켜져야 합니다.
            </StyledDescription>
          </StyledPrincipleContent>
          <StyledPrincipleContent>
            <StyledTitle>
              모든 사람들을
              <br />
              소중하게 생각합니다
            </StyledTitle>
            <StyledDescription>
              구성원, 투자자, 고객, 우리와 함께하는 모든 사람들을
              <br />
              소중하게 생각합니다. 우리는 돈을 다루기 위해 모였지만
              <br />
              가장 중요한 본질은 사람이라는 사실을 항상 기억합니다.
            </StyledDescription>
          </StyledPrincipleContent>
        </StyledPrincipleList>
      </StyledPrincipleContentsContainer>
    </StyledPrinciple>
  );
}

const StyledPrinciple = styled.article`
  padding-top: 200px;

  ${({ theme }) => theme.mobile`
    padding-top: 134px;
  `}
`;

const StyledPrincipleContentsContainer = styled.ul`
  max-width: 1340px;
  padding: 0 30px;
  margin: 0 auto;
`;

const StyledPrincipleList = styled.ul`
  ${({ theme }) => theme.flex('row', 'space-between', 'stretch')}
  flex-wrap: wrap;

  li:nth-child(2),
  li:nth-child(3) {
    background-color: ${({ theme }) => theme.colors.white};
  }

  li:nth-child(1),
  li:nth-child(4) {
    background-image: url('images/About/principle/group10@2x.png');
    background-position: right bottom;
    background-repeat: no-repeat;
    background-size: cover;
    background-color: ${({ theme }) => theme.colors.white};
  }

  li:last-child {
    ${({ theme }) => theme.mobile`
      margin-bottom: 0;
    `}
  }

  ${({ theme }) => theme.mobile`
    ${({ theme }) => theme.flex('column')}
  `}
`;

const StyledTag = styled.h2`
  margin-bottom: 18px;
  color: ${({ theme }) => theme.colors.green};

  ${({ theme }) => theme.mobile`
    margin-bottom: 10px;
  `}
`;

const StyledPrincipleContent = styled.li`
  width: 47.8%;
  padding: 3.6%;
  margin-bottom: 56px;

  ${({ theme }) => theme.mobile`
    width: 100%;
    margin-bottom: 28px;
    padding: 9.35%;
  `}
`;

const StyledTitle = styled.p`
  margin-bottom: 18px;
  font-size: 30px;
  font-weight: 700;
  line-height: 1.5;

  ${({ theme }) => theme.mobile`
  margin-bottom: 10px;
  font-size: ${({ theme }) => theme.pixelToRem(24)};
  `}
`;

const StyledDescription = styled.p`
  line-height: 1.6;

  ${({ theme }) => theme.mobile`
  font-size: ${({ theme }) => theme.pixelToRem(14)};
  `}
`;
